<template>
    <div class="integration-config">
        <div class="integration-config-card ">
        <div class="skeleton-feature-loading">
            <div class="tree-node-component skeleton-feature">
            <div class="skeleton-line" style="width: 60%;"></div>
            </div>
            <div class="tree-node-component skeleton-feature">
            <div class="skeleton-line"  style="width: 40%;"></div>
            </div>
        </div>
        </div>
    </div>

  </template>
  <script lang="ts">
  import { defineComponent } from 'vue'
  export default defineComponent({
    name: 'IntegrationSkeletonLoadingComponent'
  })
  </script>
  <style lang="scss" scoped>
  .skeleton-feature-loading{
    margin: var(--space-0) !important;
    .skeleton-feature{
      height: 20px !important;
      background: var(--light-300) !important;
    }
  }

  .skeleton-add-integration{
    background: var(--light-300);
    .integration-config-card{
      display: flex;
      align-items: center;
      background-color: var(--card-bg);
    }
    .integration-icon{
      color: var(--neutral-100) !important;
    }
    .skeleton-feature-loading{
      width: 100%;
    }
    .skeleton-feature{
      background: var(--light-300) !important;
      &::after{
        animation: none !important
      }
    }
  }

  </style>